const normalizePart = (value: string) => value.trim().replace(/\s+/g, ' ')
const normalizeComparable = (value: string) => normalizePart(value).toLowerCase()

export const ADMIN_SCHEMA_NAME = 'Administration'

export type ParsedTypeName = {
  schema: string | null
  tableName: string
  hasSchema: boolean
}

export const parseTypeName = (name: string): ParsedTypeName => {
  const trimmed = name.trim()
  if (!trimmed) return { schema: null, tableName: '', hasSchema: false }

  const match = trimmed.match(/^(.*?)\s*--\s*(.+)$/)
  if (!match) return { schema: null, tableName: trimmed, hasSchema: false }

  const schema = normalizePart(match[1])
  const tableName = normalizePart(match[2])
  if (!schema || !tableName) return { schema: null, tableName: trimmed, hasSchema: false }

  return { schema, tableName, hasSchema: true }
}

export const formatTypeName = (schema: string, tableName: string) =>
  `${normalizePart(schema)} -- ${normalizePart(tableName)}`

export const getTypeDisplayName = (name: string) => parseTypeName(name).tableName

export const isTypeInSchema = (name: string, schema: string, tableName?: string) => {
  const parsed = parseTypeName(name)
  if (!parsed.hasSchema || !parsed.schema) return false
  if (normalizeComparable(parsed.schema) !== normalizeComparable(schema)) return false
  if (!tableName) return true
  return normalizeComparable(parsed.tableName) === normalizeComparable(tableName)
}

export const typeNameMatchesTable = (name: string, tableName: string) =>
  normalizeComparable(getTypeDisplayName(name)) === normalizeComparable(tableName)
